// extracted by mini-css-extract-plugin
export var backButton = "_m-1";
export var content = "_m-d";
export var continueButton = "_m-7";
export var continueHint = "_m-8";
export var continueRow = "_m-6";
export var leftInner = "_m-0";
export var shell = "_m-e";
export var sidebarContent = "_m-5";
export var skipButton = "_m-c";
export var spacer = "_m-2";
export var spin = "_m-a";
export var spinner = "_m-9";
export var spinnerOverlay = "_m-b";
export var subtitle = "_m-4";
export var title = "_m-3";